import { $api } from 'api/http'
import { IProduct, IProductCharacteristic } from 'api/types/product'
import { IUrlParams } from 'api/types/url-params'

class ProductApiService {
  getProducts({ id, page, limit = 50, search, filters }: IUrlParams) {
    return $api.post<Array<IProduct>>(`/scu/${id}/${page}/${limit}`, {
      filters,
      search,
    })
  }
  getProductCharacteristics(id: string) {
    return $api.get<IProductCharacteristic>(`/characteristics/${id}`)
  }
  deleteProduct(id: string) {
    return $api.delete<Array<IProduct>>('/cart', { data: { id } })
  }
}

export const productApiService = new ProductApiService()
